export const UPLOAD_FILE = "UPLOAD_FILE";
export const GET_ALL_ADVERTS = "GET_ALL_ADVERTS";
export const DELETE_ADVERT = "DELETE_ADVERT";
export const EDIT_ADVERT = "EDIT_ADVERT";
export const GET_ALL_ACTIONS = "GET_ALL_ACTIONS";
export const CHANGE_ACTION = "CHANGE_ACTION";
export const DELETE_UPLOAD_IMAGE = "DELETE_UPLOAD_IMAGE"